import { render, staticRenderFns } from "./flGoalXiugaiShenpi.vue?vue&type=template&id=2f81f124&scoped=true"
import script from "./flGoalXiugaiShenpi.vue?vue&type=script&lang=js"
export * from "./flGoalXiugaiShenpi.vue?vue&type=script&lang=js"
import style0 from "./flGoalXiugaiShenpi.vue?vue&type=style&index=0&id=2f81f124&prod&scoped=true&lang=css"
import style1 from "./flGoalXiugaiShenpi.vue?vue&type=style&index=1&id=2f81f124&prod&lang=css"
import style2 from "./flGoalXiugaiShenpi.vue?vue&type=style&index=2&id=2f81f124&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81f124",
  null
  
)

export default component.exports